<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile aria-label="Abrir/Encolher menu lateral sub." title="Abrir/Encolher menu lateral sub." />
      <b-link class="navbar-brand" to="/">
        <h1 style="display: none">ATENDE-LIBRAS</h1>
        <h6 class="navbar-brand-full" width="50" height="25" alt="Atende Libras">ATENDELIBRAS</h6>
      </b-link>
      <SidebarToggler aria-label="Abrir/Encolher menu lateral" title="Abrir/Encolher menu lateral" class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer aria-label="Abrir/Encolher menu lateral, parte de baixo" title="Abrir/Encolher menu lateral parte de baixo"/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <span class="ml-1">ATENDELIBRAS &copy; 2019</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import navBasico from '@/_navBasico'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from '@/templates/containers/DefaultAside'
import DefaultHeaderDropdown from '@/templates/containers/DefaultHeaderDropdown'
import DefaultHeaderDropdownNotif from '@/templates/containers/DefaultHeaderDropdownNotif'
import DefaultHeaderDropdownAccnt from '@/templates/containers/DefaultHeaderDropdownAccnt'
import DefaultHeaderDropdownMssgs from '@/templates/containers/DefaultHeaderDropdownMssgs'
import DefaultHeaderDropdownTasks from '@/templates/containers/DefaultHeaderDropdownTasks'
import SessionStorage from '@/services/session-storage'

export default {
  name: 'SiteTemplate',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    DefaultHeaderDropdownMssgs,
    DefaultHeaderDropdownNotif,
    DefaultHeaderDropdownTasks,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  created () {
    let usuario = SessionStorage.get('usuario')

    if (!usuario) {
      this.$router.push('/login')
    }
    this.$store.dispatch('atualizarPermissoes')
  },
  computed: {
    nav () {
      if (this.can('orgao.index') || this.can('unidade.index')) {
        return nav.items
      } else {
        return navBasico.items
      }
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    }
  }
}
</script>

<style lang="scss" scoped>
  // CoreUI Icons Set
  @import '@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import 'flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import 'bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import '../../assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/templates/site-interno/SiteTemplate.vue